// Аддон аналитики: имя комнаты — это секрет приглашения (по нему заходят в звонок),
// поэтому в Amplitude уходит только его хеш: первые 16 hex-символов SHA-256.
// Чистые функции без зависимостей от остального фронта (тестируются из backend vitest).

const cache: Record<string, string> = {};

export const roomHash = async (name: unknown): Promise<string> => {
  try {
    if (typeof name !== 'string' || !name) return '';
    if (cache[name]) return cache[name];
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(name));
    const hex = Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
    const short = hex.slice(0, 16);
    cache[name] = short;
    return short;
  } catch (e) {
    return '';
  }
};

// Уже посчитанный хеш (синхронно) — для событий на закрытии вкладки.
export const cachedRoomHash = (name: unknown): string => {
  try {
    return typeof name === 'string' && name ? (cache[name] || '') : '';
  } catch (e) {
    return '';
  }
};

// Адрес звонка /call/<имя комнаты> в свойствах автособытий SDK (просмотр страницы и т.п.)
// заменяется на /call/:room — имя комнаты не должно уходить и так.
const CALL_PATH = /(\/call\/)[^/?#\s"]+/g;
export const maskCallPath = (value: unknown): unknown => {
  try {
    return typeof value === 'string' ? value.replace(CALL_PATH, '$1:room') : value;
  } catch (e) {
    return value;
  }
};

// Маска для всех строковых значений объекта свойств, на один уровень вглубь
// (у identify свойства лежат внутри $set / $setOnce).
export const maskCallPathsIn = (props: unknown): unknown => {
  try {
    if (!props || typeof props !== 'object') return props;
    const out: Record<string, unknown> = {};
    Object.keys(props as Record<string, unknown>).forEach(k => {
      const v = (props as Record<string, unknown>)[k];
      if (v && typeof v === 'object' && !Array.isArray(v)) {
        const inner: Record<string, unknown> = {};
        Object.keys(v as Record<string, unknown>).forEach(k2 => {
          inner[k2] = maskCallPath((v as Record<string, unknown>)[k2]);
        });
        out[k] = inner;
      } else {
        out[k] = maskCallPath(v);
      }
    });
    return out;
  } catch (e) {
    return props;
  }
};
